module.exports = __webpack_public_path__ + "static/media/harina_integral.27911ec9.png";